import React from 'react'
import { Link } from 'react-router-dom'

import { FaMediumM } from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6'
import { FaTelegramPlane } from 'react-icons/fa'
import { IoIosCloseCircle } from 'react-icons/io'

const NAV_LINKS = [
  {
    name: 'ABOUT',
    linkPath: '#about',
  },
  {
    name: 'NFT HODLERS',
    linkPath: '#nft',
  },
  {
    name: 'FEATURES',
    linkPath: '#features',
  },
  {
    name: 'PREMIUM SERVICE',
    linkPath: '#premiumservices',
  },
]

export default function MobileMenu({ setMenuShow }) {
  const HandleClose = () => {
    setMenuShow(false)
  }

  return (
    <div className='absolute top-0 bg-black w-full h-screen transetion delay-100 ease-out duration-150 text-white py-10 px-5 animation'>
      <span
        className='absolute top-7 right-7'
        onClick={HandleClose}
      >
        <IoIosCloseCircle className='text-2xl' />
      </span>
      <div className='pl-10'>
        <ul className='flex flex-col gap-6  mt-10'>
          {NAV_LINKS.map((item, index) => (
            <li
              key={index}
              className='font-semibold'
            >
              <a
                href={item.linkPath}
                className='animate__backInDown wow animate__animated'
              >
                {item.name}
              </a>
            </li>
          ))}
        </ul>
        <div className='flex items-center gap-5 mt-6'>
          <a
            href=''
            className='text-2xl'
          >
            <FaMediumM />
          </a>
          <a
            href=''
            className='text-2xl'
          >
            <FaXTwitter />
          </a>
          <a
            href=''
            className='text-2xl'
          >
            <FaTelegramPlane />
          </a>
        </div>
      </div>
    </div>
  )
}
